import { FormSelect, FormTextarea } from "components/BaseForm";
import { REQUIRED_MARK } from "components/BaseForm/fields/fieldClasses";
import { HoldMessageFormPreview } from "components/HoldMessagePreview";
import HoldMessageVoiceFields from "components/HoldMessageVoiceFields";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { FieldLegend, FieldSet } from "components/ui/field";
import { useHoldMessageLanguages } from "hooks/useHoldMessageLanguages";
import { HOUR_OPTIONS } from "routes/settings/global/globalSettingsForm";
import { VoicemailFileField } from "routes/settings/global/VoicemailFileField";
import { ZendeskNumberField } from "routes/settings/global/ZendeskNumberField";

export function CallCenterCard() {
  const { languages, isLoading } = useHoldMessageLanguages();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Call Center</CardTitle>
      </CardHeader>
      <CardContent className="tw:flex tw:flex-col tw:gap-5">
        <FieldSet>
          <FieldLegend variant="label" className={REQUIRED_MARK}>
            Default Call Window
          </FieldLegend>
          <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-2">
            <FormSelect
              name="call_center.call_window_start"
              label="Call Window Start"
              options={HOUR_OPTIONS}
            />
            <FormSelect
              name="call_center.call_window_end"
              label="Call Window End"
              options={HOUR_OPTIONS}
            />
          </div>
        </FieldSet>
        <ZendeskNumberField />
        <VoicemailFileField
          name="call_center.system_voicemail"
          label="System Voicemail"
        />
        <FormTextarea
          name="call_center.hold_message"
          label="Hold Message"
          placeholder="Using the system default hold message"
          rows={3}
        />
        <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-2">
          <HoldMessageVoiceFields
            languageName="call_center.hold_message_language"
            voiceName="call_center.hold_message_voice"
            languages={languages}
            disabled={isLoading}
          />
        </div>
        <HoldMessageFormPreview
          messageName="call_center.hold_message"
          languageName="call_center.hold_message_language"
          voiceName="call_center.hold_message_voice"
        />
      </CardContent>
    </Card>
  );
}
